export const downloadBlob = (blob: any, name: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name)
    link.click();
}